export default "__VITE_ASSET__bd792b5a__"